import React, { useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import gallery1 from "../assets/images/gallery/gallery_01.jpg";
import gallery2 from "../assets/images/gallery/gallery_02.jpg";
import gallery3 from "../assets/images/gallery/gallery_03.jpg";
import gallery4 from "../assets/images/gallery/gallery_04.jpg";
import gallery5 from "../assets/images/gallery/gallery_05.jpg";
import gallery6 from "../assets/images/gallery/gallery_06.jpg";

function Gallery() {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryImages = [
    { id: 1, image: gallery1, size: "lg" },
    { id: 2, image: gallery2, size: "md" },
    { id: 3, image: gallery3, size: "md" },
    { id: 4, image: gallery4, size: "lg" },
    { id: 5, image: gallery5, size: "md" },
    { id: 6, image: gallery6, size: "md" },
  ];

  const images = galleryImages.map((item) => ({
    original: item.image,
    thumbnail: item.image,
  }));

  const handleClose = () => setIsOpen(false);

  return (
    <section id="gallery" className="section-padding bg-white">
      <div className="container mx-auto px-6">
        <header className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-sm font-bold text-blue-600 uppercase tracking-[0.3em] mb-4">Gallery</h2>
          <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 tracking-tight">현장 갤러리</h1>
          <p className="text-lg text-slate-600 font-light">워터피아는 고객의 꿈을 실현하는 순간에 함께합니다.</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 auto-rows-[200px]">
          {galleryImages.map((item, index) => (
            <div
              key={item.id}
              className={`group relative cursor-pointer overflow-hidden rounded-[2rem] premium-shadow ${item.size === "lg" ? "md:col-span-2 md:row-span-2" : "md:col-span-1 md:row-span-1"
                }`}
              onClick={() => {
                setCurrentIndex(index);
                setIsOpen(true);
              }}
            >
              <img
                src={item.image}
                alt={`Gallery ${item.id}`}
                className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-blue-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <svg className="w-12 h-12 text-white transform scale-90 group-hover:scale-100 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                </svg>
              </div>
            </div>
          ))}
        </div>

        {isOpen && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/95 backdrop-blur-sm" onClick={handleClose} />
            <button className="absolute top-8 right-8 z-[110] text-white/50 hover:text-white transition-colors" onClick={handleClose}>
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div className="relative z-[105] w-full max-w-6xl">
              <ImageGallery
                items={images}
                startIndex={currentIndex}
                showPlayButton={false}
                showFullscreenButton={false}
                showThumbnails={false}
                onSlide={setCurrentIndex}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Gallery;
